import {
  dropdownMenuContent,
  dropdownMenuItem,
  dropdownMenuItemIndicator,
} from '../dropdown-menu/dropdown-menu.css.ts';
import { inputContainer, inputVariants } from '../input/input.css.ts';
import { themeVars } from '../theme/vars.ts';
import { borderRadius, space } from '../tokens.ts';
import { typography } from '../typography.ts';
import { globalStyle, style, styleVariants } from '../layer.css';

export const selectTrigger = style([{ cursor: 'pointer' }]);

// not possible to pass classname to SelectPrimitive.Value
globalStyle(`.${selectTrigger} > span[data-select-value]`, {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export const selectTriggerVariants = styleVariants({
  /*
   * note: ghost variant is not per spec.
   * By spec it should be <Button variant="ghost"> but it doesn't look good in the only place it's used
   * TODO: clarify ghost select trigger usage and probably prefer asChild pattern instead of variant here
   */
  ghost: [
    typography['labelMd'],
    {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: space.s2,
      padding: `${space.s3}px 0`,
      color: themeVars.controls.foreground.default,
      borderRadius: borderRadius.r8,

      ':hover': {
        color: themeVars.controls.foreground.input,
      },
      ':focus-visible': {
        outline: `1px solid ${themeVars.controls.border.active}`,
      },
    },
  ],
  outline: [
    inputContainer,
    inputVariants.default,
    {
      paddingLeft: space.s16,
      paddingRight: space.s16,

      selectors: {
        '&[data-placeholder]': {
          color: themeVars.controls.foreground.default,
        },
        '&[data-state="open"]': {
          outlineColor: themeVars.controls.border.active,
        },
      },
    },
  ],
});

globalStyle(`.${selectTriggerVariants.outline}:not([data-placeholder]) svg`, {
  color: themeVars.controls.foreground.input,
});

globalStyle(`:where(.${selectTrigger})`, {
  all: 'unset',
  boxSizing: 'border-box',
});

export const selectClearButton = style({
  selectors: {
    [`${selectTrigger}[data-placeholder] &`]: {
      display: 'none',
    },
  },
});

export const selectIcon = style({});

export const selectContent = style([
  dropdownMenuContent,
  {
    // works only with position="popper"
    maxHeight: 'min(var(--radix-select-content-available-height), 400px)',
    width: 'var(--radix-select-trigger-width)',
  },
]);

export const selectViewport = style({});

export const selectItem = style([dropdownMenuItem]);

export const selectItemIndicator = style([dropdownMenuItemIndicator]);

export const selectTriggerAside = style({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: space.s6,
  marginLeft: 'auto',
});

export const selectLabel = style([
  typography['labelSm'],
  {
    padding: `${space.s8}px ${space.s12}px`,
    margin: `0 ${space.s4}px`,
    backgroundColor: themeVars.dropdownMenu.background.default,
    color: themeVars.container.foreground.tertiary,
  },
]);

export const selectScrollButton = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: themeVars.dropdownMenu.background.default,

  selectors: {
    '&[data-direction="up"]': {
      paddingBottom: space.s4,
    },
    '&[data-direction="down"]': {
      paddingTop: space.s4,
    },
  },
});

globalStyle(`.${selectScrollButton} > svg`, {
  width: '18px',
  height: '18px',
});
